import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSuggestionFreestyleTool,
  BackendMutationCreateCustomerSuggestionFreestyleToolArgs,
} from 'src/types/backend';

import { FRAGMENT_FREESTYLE_TOOL } from './schema';

const MUTATION = gql`
  mutation CreateCustomerSuggestionFreestyleTool(
    $customerId: ID!
    $workspaceId: ID
    $name: String!
    $allInstructionsData: JSON
    $generationTool: String
  ) {
    createCustomerSuggestionFreestyleTool(
      customerId: $customerId
      workspaceId: $workspaceId
      name: $name
      allInstructionsData: $allInstructionsData
      generationTool: $generationTool
    ) {
      ...SuggestionFreestyleTool
    }
  }
  ${FRAGMENT_FREESTYLE_TOOL}
`;

type Variables = BackendMutationCreateCustomerSuggestionFreestyleToolArgs;
type Result = BackendCustomerSuggestionFreestyleTool;

export const createSuggestionFreestyleTool = async ({
  allInstructionsData,
  ...rest
}: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      allInstructionsData: stringifyIfPresent(allInstructionsData),
    },
  });

  const result = getSingleProp<Result>(response.data);
  if (result) {
    result.allInstructionsData = result.allInstructionsData
      ? JSON.parse(result.allInstructionsData as string)
      : null;
  }
  return result;
};
